import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Placeholder from '../../../../components/Placeholder';
import { Container, Tabs, Tab, Text, Linker } from './HeaderTab.style';

const HeaderTab = ({ current, sublimicDiagnosisResults, changeCurrentScene, scrolled }) => (
  <Container>
    <Tabs className={current || ''}
      style={{
        backgroundColor: scrolled ? '#ebebeb' : 'transparent',
        boxShadow: scrolled ? '0px 5px 5px rgba(0, 0, 0, 0.1), 0px 5px 5px rgba(0, 0, 0, 0.1) inset' : 'none',
        transitionProperty: 'background-color box-shadow',
        transitionDuration: '0.2s',
      }}
    >
      <Tab className="item"
        style={{
          borderColor: scrolled ? 'transparent' : '#999ea2',
        }}
      >
        <Linker href="#" onClick={e => {
            e.preventDefault();
            changeCurrentScene('top');
          }}
        >
          <Text className="text">
            {_.get(sublimicDiagnosisResults, 'summary') && sublimicDiagnosisResults.summary.menuLinkText ? sublimicDiagnosisResults.summary.menuLinkText : <Placeholder w="100px" h="20px" />}
          </Text>
        </Linker>
      </Tab>
      <Tab className="item"
        style={{
          borderColor: scrolled ? 'transparent' : '#999ea2',
        }}
      >
        <Linker href="#" onClick={e => {
            e.preventDefault();
            changeCurrentScene('care');
          }}
        >
          <Text className="text">
            {_.get(sublimicDiagnosisResults, 'salonCare') && sublimicDiagnosisResults.salonCare.menuLinkText ? sublimicDiagnosisResults.salonCare.menuLinkText : <Placeholder w="100px" h="20px" />}
          </Text>
        </Linker>
      </Tab>
      <Tab className="item"
        style={{
          borderColor: scrolled ? 'transparent' : '#999ea2',
        }}
      >
        <Linker href="#" onClick={e => {
            e.preventDefault();
            changeCurrentScene('home-care');
          }}
        >
          <Text className="text">
            {_.get(sublimicDiagnosisResults, 'HomeCare') && sublimicDiagnosisResults.HomeCare.menuLinkText ? sublimicDiagnosisResults.HomeCare.menuLinkText : <Placeholder w="100px" h="20px" />}
          </Text>
        </Linker>
      </Tab>
      <Tab className="item"
        style={{
          borderColor: scrolled ? 'transparent' : '#999ea2',
        }}
      >
        <Linker href="#" onClick={e => {
            e.preventDefault();
            changeCurrentScene('confirm');
          }}
        >
          <Text className="text">
            {_.get(sublimicDiagnosisResults, 'confirmation') && sublimicDiagnosisResults.confirmation.menuLinkText ? sublimicDiagnosisResults.confirmation.menuLinkText : <Placeholder w="100px" h="20px" />}
          </Text>
        </Linker>
      </Tab>
    </Tabs>
  </Container>
);

HeaderTab.defaultProps = {
  copy: {},
  current: '',
  changeCurrentScene: null,
};
HeaderTab.propTypes = {
  copy: PropTypes.shape(),
  current: PropTypes.string,
  changeCurrentScene: PropTypes.func.isRequired,
};

export default HeaderTab;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/HeaderTab/HeaderTab.js